import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { linkToGZ } from '@/utils';

import ArrowLeft from '@/assets/icon/Olybet/arrow-left.svg';
import BingolyLogo from '@/assets/images/Olybet/bingoly.svg';

import { useJWT } from '@/hooks/useJWT.hook';
import { useLocalStorage } from '@/hooks/useLocalStorage.hook';
import { useSettings } from '@/hooks/useSettings.hook';

import LangSwitcher from '@/components/LangSwitcher';

import { RoutesEnum } from '@/enums/routes.enum';
import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { tKeys } from '@/i18n/resourses';

import * as S from './HeaderDesktop.styles';
import { LogoutButton } from './HeaderDesktop.styles';

const HeaderDesktop: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { jwt, removeJWT } = useJWT();
  const { pagesWithBackButton } = useSettings();
  const { value: lang } = useLocalStorage<string>(StorageKeysEnum.i18nextLng);

  const handleLogout = () => {
    removeJWT();
    window.location.assign(linkToGZ(lang));
  };

  return (
    <S.Header id='header'>
      <S.Wrapper>
        {pagesWithBackButton ? (
          <S.BackToPrevPage onClick={() => navigate(RoutesEnum.play)}>
            <S.ChevronLeft alt='' src={ArrowLeft} />
            <S.BackToGameZoneText>{t(tKeys.back)}</S.BackToGameZoneText>
          </S.BackToPrevPage>
        ) : (
          <S.BackToGameZoneLink to={linkToGZ(lang)}>
            <S.ChevronLeft alt='' src={ArrowLeft} />
            <S.BackToGameZoneText>
              {t(tKeys.returnToGamezone)}
            </S.BackToGameZoneText>
          </S.BackToGameZoneLink>
        )}

        <S.LogoBox>
          <Link to={RoutesEnum.play}>
            <S.ImageLogo alt='logo' src={BingolyLogo} />
          </Link>
        </S.LogoBox>

        <S.ButtonsBox>
          {jwt && (
            <LogoutButton onClick={handleLogout}>
              {t(tKeys.logout)}
            </LogoutButton>
          )}
          <LangSwitcher />
        </S.ButtonsBox>
      </S.Wrapper>
    </S.Header>
  );
};

export default HeaderDesktop;
